import { setAuthToken } from '@jetshop/core/boot/apollo';
import { login } from '@jetshop/core/data/mutations/accountMutations.gql';
import React from 'react';
import { Mutation } from 'react-apollo';
import AuthContext from '../AuthContext/AuthContext';
class LoginMutation extends Mutation {
}
const LogInMutation = ({ children, onCompleted, onError }) => {
    return (React.createElement(AuthContext.Consumer, null, ({ updateLoggedIn }) => (React.createElement(LoginMutation, { onError: onError, onCompleted: data => {
            setAuthToken(data.login.token.value);
            updateLoggedIn(!!data.login.token);
            onCompleted && onCompleted(data);
        }, mutation: login }, (mutate, result) => {
        return children((email, password) => {
            return mutate({
                variables: {
                    email,
                    password
                }
            }).then(() => {
                result.client.resetStore();
            });
        });
    }))));
};
export default LogInMutation;
//# sourceMappingURL=LogInMutation.js.map